document.addEventListener('DOMContentLoaded', () => {  
  const categorySliders = document.querySelectorAll('.categorySlider .categorySlider__slider');
  
  categorySliders.forEach((categorySlider) => {
    const splide = new Splide(categorySlider, {
      arrows: false,
      pagination: true,
      gap: '20px',
      perPage: 4,
      autoWidth: true,
      breakpoints: {
        1405: {
          perPage: 2,
        },
        1080: {
          destroy: true,
        },
      },
    });

    splide.mount();
  });
});